const API_BASE_URL = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export async function apiJson(endpoint, options = {}) {
  const { body, headers, ...requestOptions } = options;
  const hasBody = body !== undefined;
  const response = await fetch(`${API_BASE_URL}/${endpoint.replace(/^\//, "")}`, {
    ...requestOptions,
    headers: {
      ...(hasBody ? { "Content-Type": "application/json" } : {}),
      ...headers,
    },
    ...(hasBody ? { body: typeof body === "string" ? body : JSON.stringify(body) } : {}),
  });

  const responseText = await response.text();
  let data = {};
  if (responseText) {
    try {
      data = JSON.parse(responseText);
    } catch (_) {
      throw new Error("The server returned an invalid response.");
    }
  }

  return { response, data };
}
